module.exports = __webpack_public_path__ + "static/img/02.6f7414b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/02.png
// module id = tbht
// module chunks = 1